import { Controller } from "@hotwired/stimulus"

// Monthly/annual pricing toggle for the BD subscription landing.
// Reads pricing data from value attributes on the controller root and
// flips the card content + slider position when the user clicks one of
// the two mode buttons (data-mode="monthly" / data-mode="annual").
//
// All copy (name, amount, unit, context, CTA label/href) lives in the
// values payload — no DOM templates, no fetches. Pure client-side toggle.
export default class extends Controller {
  static targets = [
    "card", "slider", "btnMonthly", "btnAnnual",
    "name", "amount", "unit", "context", "cta", "ctaLabel"
  ]
  static values = {
    monthly: Object,
    annual: Object
  }

  connect() {
    this.position()
    this.boundPosition = this.position.bind(this)
    window.addEventListener("resize", this.boundPosition)
  }

  disconnect() {
    if (this.boundPosition) {
      window.removeEventListener("resize", this.boundPosition)
    }
  }

  selectMonthly() { this.setMode("monthly") }
  selectAnnual()  { this.setMode("annual") }

  setMode(mode) {
    if (this.cardTarget.dataset.mode === mode) return
    this.cardTarget.dataset.mode = mode

    const data = mode === "annual" ? this.annualValue : this.monthlyValue

    this.btnMonthlyTarget.classList.toggle("active", mode === "monthly")
    this.btnMonthlyTarget.setAttribute("aria-selected", String(mode === "monthly"))
    this.btnAnnualTarget.classList.toggle("active", mode === "annual")
    this.btnAnnualTarget.setAttribute("aria-selected", String(mode === "annual"))

    this.position()

    if (this.hasNameTarget)     this.nameTarget.textContent     = data.name
    if (this.hasAmountTarget)   this.amountTarget.innerHTML     = data.amount
    if (this.hasUnitTarget)     this.unitTarget.textContent     = data.unit
    if (this.hasContextTarget)  this.contextTarget.innerHTML    = data.context
    if (this.hasCtaLabelTarget) this.ctaLabelTarget.textContent = data.cta
    if (this.hasCtaTarget)      this.ctaTarget.setAttribute("href", data.ctaHref)
  }

  position() {
    if (!this.hasSliderTarget) return
    const active = this.cardTarget.dataset.mode === "annual"
      ? this.btnAnnualTarget
      : this.btnMonthlyTarget
    const wrap = active.parentElement
    if (!wrap) return
    const wrapRect = wrap.getBoundingClientRect()
    const btnRect = active.getBoundingClientRect()
    this.sliderTarget.style.left = (btnRect.left - wrapRect.left) + "px"
    this.sliderTarget.style.width = btnRect.width + "px"
  }
}
